"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IssueCustomListDropdown = void 0;
var _react = _interopRequireWildcard(require("react"));
var _SelectBoxWrapper = require("../../utils/components/SelectBoxWrapper");
var _useTranslations = require("../../utils/i18n/useTranslations");
var _alloyReactDropdown = require("@adsk/alloy-react-dropdown");
var _DropdownUtils = require("../../utils/components/DropdownUtils");
var _featureFlags = require("../../utils/featureFlags");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const IssueCustomListDropdown = _ref => {
  let {
    attribute,
    required,
    value,
    error,
    onChange,
    defaultIsOpen,
    onClose,
    container,
    fieldPath,
    ...props
  } = _ref;
  const {
    value: shouldUseNewDropdown
  } = (0, _featureFlags.useFeatureFlag)(_featureFlags.FeatureFlag.OutdatedComponentMigrationPhase1Batch3);
  const options = (0, _react.useMemo)(() => {
    var _attribute$metadata$l;
    return (_attribute$metadata$l = attribute.metadata.list) === null || _attribute$metadata$l === void 0 ? void 0 : _attribute$metadata$l.options.map(_ref2 => {
      let {
        id,
        value
      } = _ref2;
      return {
        label: value,
        value: id
      };
    });
  }, [attribute]);
  const referentialValueGetter = (0, _react.useCallback)(val => val ? options.find(option => option.value === val) : null, [options]);
  const referentialValue = (0, _react.useMemo)(() => referentialValueGetter(value),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [value]);
  // We want to control the selected value so that if the value is cleared outside of the
  // SelectBox, we can update the value here
  const [selectedValue, setSelectedValue] = (0, _react.useState)(referentialValue);
  (0, _react.useEffect)(() => {
    setSelectedValue(referentialValue);
  }, [referentialValue]);
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  const handleChange = (0, _react.useCallback)(changes => {
    const selectedItem = changes === null || changes === void 0 ? void 0 : changes.selectedItem;
    onChange(selectedItem ? selectedItem.value : null);
    setSelectedValue(selectedItem !== null && selectedItem !== void 0 ? selectedItem : null);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  if (!options) {
    return null;
  }
  const OldDropdown = () => /*#__PURE__*/_react.default.createElement(_SelectBoxWrapper.SelectBoxWrapper, _extends({
    name: fieldPath,
    invalid: error,
    defaultIsOpen: defaultIsOpen,
    options: options,
    value: selectedValue,
    onChange: option => {
      onChange(option && option.value);
      setSelectedValue(option);
    },
    onClose: onClose,
    clearable: !required,
    container: container,
    placeholder: T.translate("customFieldsAdmin.placeholder.list")
  }, props));
  const semanticIdentifier = "custom-list-dropdown";
  const NewDropdown = () => {
    const {
      controlProps,
      menuProps
    } = (0, _alloyReactDropdown.useDropdown)({
      items: options !== null && options !== void 0 ? options : [],
      selectedItem: selectedValue,
      onSelectedItemChange: handleChange,
      defaultIsOpen,
      id: semanticIdentifier
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.Control, _extends({}, controlProps, {
      error: error,
      placeholder: T.translate("customFieldsAdmin.placeholder.list"),
      onBlur: onClose,
      "data-testid": "".concat(semanticIdentifier, "-control")
    })), /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.SingleSelectMenu, _extends({}, menuProps, {
      "data-testid": "".concat(semanticIdentifier, "-menu"),
      renderFooter: () => (0, _DropdownUtils.DropdownFooter)({
        isClearable: !required,
        handleChange: handleChange,
        shouldDisplay: !!(selectedValue !== null && selectedValue !== void 0 && selectedValue.value)
      })
    })));
  };
  return shouldUseNewDropdown ? NewDropdown() : OldDropdown();
};
exports.IssueCustomListDropdown = IssueCustomListDropdown;
//# sourceMappingURL=IssueCustomListDropdown.js.map